<template>
  <button
    type="button"
    class="rounded-full flex items-center gap-12 bg-[white] p-8 pe-24 ps-12 text-start transition-colors duration-[var(--raw-fast)] ease-[var(--raw-ease-out-quart)] hover:bg-[white]/70 active:bg-[white]/70"
    @click="handleClick()"
  >
    <MetalImage :metal="journey.metal" :size="48" />
    <span class="flex flex-1 flex-wrap items-baseline gap-4">
      <span class="raw-cta-1">{{ i18n(journey.metal.name) }}:</span>
      <span class="raw-body-3 text-[--raw-darkgrey]">
        {{ i18n(journey.label) }}
      </span>
    </span>
    <RevIllustration
      src="/mine-my-phone/icons/right--flat.svg"
      :width="20"
      :height="20"
      alt=""
      aria-hidden="true"
      class="rounded-full shrink-0 bg-[--raw-verylightgrey] p-4"
    />
  </button>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevIllustration } from '@ds/components/Illustration'

import MetalImage from '~/scopes/campaign/components/UI/MetalImage.vue'
import { useModalState } from '~/scopes/campaign/composables/useModalState'
import type { Journey } from '~/scopes/campaign/data/journeys/types'

// The way into a journey. Its two hosts reach it from opposite ends — the impact panel by
// `journeyFor`, the metal sheet by `journeyForMetal` — so it takes the journey itself.
const props = defineProps<{ journey: Journey; zone: string }>()

const i18n = useI18n()
const { trackClick } = useTracking()
const { openJourney } = useModalState()

function handleClick() {
  trackClick({
    zone: props.zone,
    name: `journey-${props.journey.impact}`,
    campaign: 'raw-materials',
  })
  openJourney(props.journey.impact)
}
</script>
